import { Injectable, inject } from '@angular/core';
import { Observable, catchError, EMPTY, interval, map, switchMap, takeWhile } from 'rxjs';
import { FileManagerService } from './file-manager.service';
import type { DirEntry } from '../models/api';

@Injectable({ providedIn: 'root' })
export class ScanPollingService {
  private readonly api = inject(FileManagerService);

  pollUntilScanComplete(path: string, intervalMs = 3000): Observable<DirEntry[]> {
    return interval(intervalMs).pipe(
      switchMap(() =>
        this.api.listFiles(path, { skipErrorToast: true }).pipe(
          map((data) => data.files),
          catchError(() => EMPTY),
        ),
      ),
      takeWhile((entries) => entries.some(this.isScanning), true),
    );
  }

  private isScanning(entry: DirEntry): boolean {
    return entry.plugins?.antivirus?.is_scanned === false;
  }
}
